import { PayloadAction } from "@reduxjs/toolkit";
import { CnamLookupOutputDTO } from "../model/output/cnamLookupRequestOutputDTO";
import { CnamState, CnamUpdateResponse } from "../store/cnamSlice";

export function setIsLoading(state: CnamState, action: PayloadAction<boolean>) {
  state.isLoading = action.payload;
}

export function setCnamLookup(
  state: CnamState,
  action: PayloadAction<CnamLookupOutputDTO[]>
) {
  state.cnamLookup = action.payload;
}

export function updateCnamResults(
  state: CnamState,
  action: PayloadAction<CnamUpdateResponse>
) {
  state.cnamUpdateResponse = action.payload;
}
